import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Card, Nav  } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Switch, Route, NavLink } from 'react-router-dom';
import VisitorsList from './VisitorsList/VisitorsList';
import { toastrAdd } from '../../actions';
import api from '../../api';

function AnalyticsContainer(props) {
    const { eventID, url } = props;
    const partnerID = localStorage.getItem('partnerID');
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [analytics, setAnalytics] = useState({ visitors: [] });

    const _fetchAnalytics = useCallback(() => {
        setLoading(true);

        api.analytics.getProspectumLiveAnalytics(eventID, partnerID)
            .then(response => {
                if (response.data.data.partnerAnalytics) {
                    setAnalytics(response.data.data.partnerAnalytics);
                }
            })
            .catch(error => {
                dispatch(toastrAdd({
                    code: 0,
                    type: 'error',
                    title: t('errors.analytics_error'),
                    details: `${t('general.details')}: ${error.firstError.title} - ${error.firstError.details}`
                }));
            })
            .finally(() => {
                setLoading(false)
            });
    }, [dispatch, eventID, partnerID, t]);

    useEffect(() => {
        _fetchAnalytics();
    }, [_fetchAnalytics]);

    return (
        <>
            <h3>{t('analytics.analytics')}</h3>
            <Card className="mb-0">
                <Card.Header>
                    <Nav variant="tabs">
                        <Nav.Item>
                            <NavLink to={`${url}`} strict exact className="nav-link">
                                {t('analytics.visitors')}
                            </NavLink>
                        </Nav.Item>
                    </Nav>
                </Card.Header>
            </Card>
            <Switch>
                <Route strict exact path={`${url}`}>
                    <VisitorsList
                        eventID={eventID}
                        limit={25}
                        loading={loading}
                        visitors={analytics.visitors}
                        refresh={_fetchAnalytics}
                    />
                </Route>
            </Switch>
        </>
    );
}

export default AnalyticsContainer;